import { render } from "./DeleteModuleModal.vue?vue&type=template&id=19df4242&scoped=true&ts=true"
import script from "./DeleteModuleModal.vue?vue&type=script&lang=ts"
export * from "./DeleteModuleModal.vue?vue&type=script&lang=ts"

import "./DeleteModuleModal.vue?vue&type=style&index=0&id=19df4242&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19df4242"]])

export default __exports__